<app-header></app-header>

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <!-- Filter sidebar -->
  <!-- <div *ngIf="isSidebarOpen" class="sidebar">
    <app-sidebar
      (dependeciesSelection)="dependeciesSelection($event)"
      [isDependecies]="true"
      [quarter]="quarter"
      (close)="toggleSidebar()"
    ></app-sidebar>
  </div> -->

  <div class="main-content p-t-20">
    <div class="container-fluid">
      <div>
        <p-breadcrumb
          class="max-w-full"
          [model]="breadCrumbItems"
          [home]="breadCrumbHome"
        >
          <ng-template pTemplate="item" let-item>
            <p class="b2 m-b-0">{{ item.label }}</p>
          </ng-template>
          <ng-template pTemplate="separator"> / </ng-template>
        </p-breadcrumb>
      </div>
      <div class="dis-flex flex-m flex-sb">
        <h1 class="font-medium m-b-0">Dependencies</h1>
        <div class="dis-flex">
          <div
            class="dependency-type radius-8 border-20 bg-white p-t-4 p-b-4 p-r-4 p-l-4"
          >
            <p-selectButton
              [options]="stateOptions"
              [(ngModel)]="value"
              optionLabel="label"
              optionValue="value"
            />
          </div>
          <!-- (Filter button) -->
          <!-- <button class="btn outline b2 wd-120px" (click)="toggleSidebar()">
            <ng-icon
              name="hugeFilter"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            Filters {{ filterCount > 0 ? "(" + filterCount + ")" : "" }}</button> -->
        </div>
      </div>

      <div class="body-card">
        <p-scrollPanel>
          <div class="outcome-card w-full">
            <div *ngIf="value == 'raised-to-me'">
              <div *ngIf="!isRaiseToMeLoading; else shimmerEffect">
               <ng-container *ngIf="raiseToMeLists?.length;else noData">
                <app-raised-to-me
                *ngFor="let byMe of raiseToMeLists;"
                [isDependeciesLoading]="isRaiseToMeLoading"
                [raiseToMeList]="byMe"
                (updateDelegateState)="updateDelegateState($event)"
              ></app-raised-to-me>
               </ng-container>
              </div>
            </div>
            <div *ngIf="value == 'raised-by-me'">
              <div *ngIf="!isRaiseByMeLoading; else shimmerEffect">
                <ng-container *ngIf="raiseByMeLists?.length;else noData">
                <app-raised-by-me
                  *ngFor="let toMe of raiseByMeLists;"
                  [isDependeciesLoading]="isRaiseByMeLoading"
                  [raiseByMeList]="toMe"
                  (updateReassingState)="updateReassingState($event)"
                ></app-raised-by-me>
              </ng-container>
              </div>
            </div>
          </div>
        </p-scrollPanel>
      </div>

      <app-quick-action></app-quick-action>
    </div>
  </div>
</div>

<ng-template #shimmerEffect>
  <app-shimmer-list [count]="5"></app-shimmer-list>
</ng-template>

<ng-template #noData><app-no-data-found></app-no-data-found> </ng-template>
